import axios from 'axios';
import { pathOr, propOr } from 'ramda';

import { createCustomerRegisterUrl } from '../api-urls';
import { translateToCustomer, translateToCustomerPj } from './translate-to-customer';
import translateErrors from './translate-errors';

const defaultErrorMsg = '';

function CustomerError(message, statusCode) {
  this.message = message;
  this.statusCode = statusCode;
}

const requestCreateCustomer = (customer, captchaResponse) => ({
  url: createCustomerRegisterUrl(captchaResponse),
  method: 'post',
  data: customer
});

const getNickname = (customerType, { name }) => {
  if (customerType === 'pf' && name) {
    return name.trim().replace(/ .*/, '');
  }
  if (customerType === 'guest' && name) {
    return name.trim().replace(/ .*/, '');
  }
  return '';
};

const handleCreateCustomerPfError = error => {
  const { httpStatusCode, validationErrors } = pathOr({}, ['response', 'data'], error);
  switch (httpStatusCode) {
    case 409:
      return { errors: { email: 'Não é possível usar esse e-mail, tente novamente' } };

    case 422:
      return { errors: translateErrors(validationErrors) };

    default:
      console.error(error);
      return { errors: { default: defaultErrorMsg } };
  }
};

const handleCreateCustomerPjError = error => {
  const { httpStatusCode, validationErrors, errorCode } = pathOr({}, ['response', 'data'], error);
  const translatedErrors = translateErrors(validationErrors);

  switch (httpStatusCode) {
    case 409:
      if (errorCode === 'LOGIN_CONFLICT') {
        throw new CustomerError(
          {
            buyerAlreadyRegistered:
              'e-mail já cadastrado, solicite acesso em sua empresa ou acesse nosso FAQ'
          },
          httpStatusCode
        );
      }
      throw new CustomerError(
        { cnpj: 'CNPJ já está cadastrado, solicite acesso em sua empresa ou acesse nosso FAQ' },
        httpStatusCode
      );

    case 422:
      throw new CustomerError(translatedErrors, httpStatusCode);

    default:
      throw new CustomerError({ default: '' }, httpStatusCode);
  }
};

export const createCustomerPf = async ({ customerType, customer }, recaptchaResponse) => {
  try {
    const translatedCustomer = translateToCustomer(customerType, customer);
    const { data } = await axios(requestCreateCustomer(translatedCustomer, recaptchaResponse));
    return {
      customer: {
        ...data,
        nickname: getNickname(customerType, customer)
      },
      errors: {}
    };
  } catch (error) {
    return handleCreateCustomerPfError(error);
  }
};

export const createCustomerPj = async (customer, captcha) => {
  try {
    const translatedCustomer = translateToCustomerPj(customer);
    const { data } = await axios(requestCreateCustomer(translatedCustomer, captcha));

    return {
      customer: {
        ...data,
        nickname: propOr('', 'corporateName', data)
      }
    };
  } catch (error) {
    throw handleCreateCustomerPjError(error);
  }
};
